module.exports = "../dist/frontend/icons/ui/fb.svg?48fe2726e4b916f13cf7cfd247092e84";